import React from "react";
import "../../SearchProperty.scss";
import Button from "components/Button/Button";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LocationsDropdown from "./components/LocationsDropdown";
import CheckInDropDown from "./components/CheckInDropDown";
import AddGuestDropDown from "./components/AddGuestDropDown";
import CheckOutDropDown from "./components/CheckOutDropDown";
import { useAppDispatch, useAppSelector } from "store/store";
import { searchSelector, activeFilters, setSearchActiveStatus } from "features/search-property/searchproperty.slice";
import { clearSearchResult } from "features/search-result/searchresult.slice";
import useLocalStorage from "hooks/useLocalStorage";

const SearchBar: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();
  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const { locations, checkin, checkout, guests, filters } = useAppSelector(searchSelector);
  const locationChange = () => {
    let params: any = filters ? { ...filters } : {};
    if (Object.entries(params).length > 0) {

      // eslint-disable-next-line
      params = Object.entries(params).filter((item) => {
        if (item[0] === "longitude" || item[0] === "latitude" || item[0] === "from"
          || item[0] === "to" || item[0] === "guests") { return item }
      })
        .reduce((accum: any, [k, v]) => {
          accum[k] = v;
          return accum;
        }, {});

    }
    const inputs: any = document.querySelector(".refine")?.getElementsByTagName('input');
    if (inputs) {
      for (let index = 0; index < inputs.length; ++index) {
        inputs[index].checked = false
      }

    }
    params['locations'] = locations.currentLocation ?? null;
    params['latitude'] = locations.lat ?? null;
    params['longitude'] = locations.long ?? null;
    params['from'] = checkin.formattedD ?? null;
    params['to'] = checkout.formattedD ?? null;
    params['guests'] = guests.currentGuests.adult > 0 ? guests.currentGuests.adult : null;
    params['location'] = locations.id ?? null;
    params['page'] = 1;
    dispatch(clearSearchResult());
    dispatch(activeFilters(params));
    dispatch(setSearchActiveStatus(true));
    if (!window.location.href.includes('search-result')) {
      history.push("/search-results");
    }
  };
  // eslint-disable-next-line
  const [contDir, setContDir] = useLocalStorage("contentDir", "ltr");
  return (
    <>
      <div>
        <div dir={contDir} className="searchbar">
          <div className="box">
            <LocationsDropdown></LocationsDropdown>
            <CheckInDropDown></CheckInDropDown>
            <CheckOutDropDown></CheckOutDropDown>
            <AddGuestDropDown></AddGuestDropDown>
            <Button
              buttonText={t('search.title')}
              isPrimary={false}
              classes="searchbar-btn show-small"
              onClick={locationChange}
            ></Button>
            <button
              className="staycae-btn button is-secondary searchbar-icon hide-small"
              onClick={locationChange}
            >
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchBar;
